/**
 * ChordBook Pro wordmark and mark.
 *
 * Drawn inline as SVG so it inherits the current colour and needs no asset
 * request. The mark is a chord diagram — a 3×3 fret grid with three finger
 * dots that trace a right-pointing "play" triangle; the root dot is slightly
 * larger. Keep the geometry in sync with the mobile twin
 * (apps/mobile/src/components/brand/LogoMark.jsx) and the asset sources in
 * scripts/brand/.
 */

import { config } from '../../config/appConfig.js';
import styles from './Logo.module.css';

export function LogoMark({ size = 28, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      {/* Strings */}
      <path
        d="M9 6.75v18.5M16 6.75v18.5M23 6.75v18.5"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        opacity="0.45"
      />
      {/* Frets */}
      <path
        d="M6.75 9h18.5M6.75 16h18.5M6.75 23h18.5"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        opacity="0.45"
      />
      {/* Fingering — the dots form a play triangle; the root is larger */}
      <circle cx="9" cy="12.5" r="2.6" fill="currentColor" />
      <circle cx="9" cy="19.5" r="2.6" fill="currentColor" />
      <circle cx="23" cy="16" r="3.05" fill="currentColor" />
    </svg>
  );
}

export function Logo({ size = 28, showName = true, className = '' }) {
  return (
    <span className={`${styles.logo} ${className}`}>
      <LogoMark size={size} className={styles.mark} />
      {showName && <span className={styles.name}>{config.appName}</span>}
    </span>
  );
}
